export const supplierStockTransitionStates = {
  disabled: "disabled",
  active: "active",
  expired: "expired",
};

const ISO_8601_WITH_OFFSET = /^(?:\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2}))$/;

export const getSupplierStockTransitionState = ({
  consolidatedExperienceEnabled,
  decommissionAt,
} = {}, now = Date.now()) => {
  if (!consolidatedExperienceEnabled || typeof decommissionAt !== "string" || !ISO_8601_WITH_OFFSET.test(decommissionAt)) {
    return supplierStockTransitionStates.disabled;
  }

  const decommissionAtTimestamp = Date.parse(decommissionAt);
  if (Number.isNaN(decommissionAtTimestamp)) {
    return supplierStockTransitionStates.disabled;
  }

  return now < decommissionAtTimestamp
    ? supplierStockTransitionStates.active
    : supplierStockTransitionStates.expired;
};

export const getSupplierStockDaysRemaining = (decommissionAt, now = Date.now()) => {
  const decommissionAtTimestamp = Date.parse(decommissionAt);
  if (Number.isNaN(decommissionAtTimestamp)) {
    return 0;
  }

  return Math.max(0, Math.ceil((decommissionAtTimestamp - now) / (24 * 60 * 60 * 1000)));
};
